/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterplanlabel3m2Inputs */



/**
* | output |
* | --- |
* | "3 months" |
*
* @param {Monsterplanlabel3m2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterplanlabel3m2 = /** @type {((inputs?: Monsterplanlabel3m2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterplanlabel3m2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("3 months")
	if (locale === "es") return /** @type {LocalizedString} */ ("3 meses")
	return /** @type {LocalizedString} */ ("3 месяца")
});
export { monsterplanlabel3m2 as "monsterPlanLabel3m" }